import React, { Component } from 'react';


import { getUnitWp, r2h } from '../vodjs/lib';
import { getHrsMinsAmpmStr, clearFetch, getShared, DAYS_OF_WEEK_ABBREV } from '../vodjs/Utils';
import Header from '../components/DRHeader';
import { noSelect, turqoiseBtnStyle, pleasantGreen, pleasantOrange, alertRed } from '../constants/Styles';
import { ShortMonth } from '../constants/DateTime';
import WebPicker from '../components/WebPicker';
import { getConfig } from '../utils/configUtils';
import { elasticLogEvent, elasticLogError } from '../vodjs/ElasticLog';


const ascDates = false;


let swipeCodeMap = {
  0: 'Success',
  1: 'Badge not found',
  2: 'Insufficient privs',
  3: 'Incorrect PIN'
};


//https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression
//Note that I added leading ^ and trailing $, and it must be run against .toLowerCase()
const emailRE = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;


function getDefaultSpanStart() {
  return Date.now() - 1000 * 60 * 60 * 24 * (7 * 4 - 1); //four weeks of dates (including today's date)
}


function getBadgeId(swipe, showNames) {
  if (swipe.rocOverride)
    return `Diligent_Services`;

  // autoPrio feature flag showBadgeReportNames
  if (showNames) {
    let nameStr = swipe.name ? ` [${swipe.name}]` : '';
    return swipe.badgeId + nameStr;
  }
  else {
    return swipe.badgeId;
  }
}


export default class BadgeReport extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      memEmails: [],
      expanded: {},
    };

    this.emailRef = React.createRef();
    this.scrollRef = React.createRef();
  }


  async componentDidMount() {
    let unit = this.props.station;
    if (unit == '*') unit = undefined;
    let body = { unit };

    this.interactionTicks = Date.now();

    const expandBadgeStr = badgesStr => {

      if (typeof (badgesStr) != 'string') {
        return badgesStr;
      }

      try {
        return JSON.parse(badgesStr);
      }
      catch (err) {
        return [];
      }
    };

    let badgeData;
    await this.tokenCallMbotSrvr('getBadgeData', body,
      json => {
        badgeData = json;

        //latch-expands
        badgeData.badges.forEach(rec => {
          rec.pickupBadges = expandBadgeStr(rec.pickupBadges);
          rec.dropoffBadges = expandBadgeStr(rec.dropoffBadges);
        })

        this.setState({ loading: undefined, badgeData });
      },
      ({ logStr }) => {
        let msg = `Error loading task data: ` + logStr;
        elasticLogError({ what: 'badgeDataLoadErr', msg })
        this.setState({ loading: undefined, loadErr: msg });
      }
    );
    if (!badgeData) return;

    console.log('BadgeReport: earliestTaskTicks: ' + new Date(badgeData.earliestTaskTicks));

    //generate list of dates from which reports can be started
    this.startDates = [];
    if (badgeData.badges.length && badgeData.earliestTaskTicks) {
      let endDateLabel = 'Now', endTicks = Date.now();
      let d = new Date();
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0);

      d.setDate(d.getDate() - d.getDay());
      for (; ;) {
        let [year, monthZ, date] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let startDateLabel = `Sunday ${ShortMonth[monthZ]} ${date}`;

        let startTicks = d.getTime();

        this.startDates[ascDates ? 'unshift' : 'push']({ year, monthZ, date, startDateLabel, endDateLabel, startTicks, endTicks });

        //safety/sanity
        if (this.startDates.length > 10) break;

        if (startTicks < badgeData.earliestTaskTicks) break;

        let nextInclEndDate = new Date(d);
        nextInclEndDate.setDate(nextInclEndDate.getDate() - 1);
        endDateLabel = `Saturday ${ShortMonth[nextInclEndDate.getMonth()]} ${nextInclEndDate.getDate()}`;

        endTicks = startTicks;
        d.setDate(d.getDate() - 7);
      }
    }

    this.startDateKeys = this.startDates.map((_, i) => i);

    const checkScrollTicks = 1000 * 15;
    const autoExitTicks = 1000 * 60 * 3;   //arbitrary; must be > checkScrollTicks, ideally multiples

    this.prevScrolltop = 0;
    this.checkScrollInterval = setInterval(() => {
      if (!this.scrollRef.current) return;
      let scrollTop = this.scrollRef.current.scrollTop;
      if (this.prevScrolltop != scrollTop) {
        this.prevScrolltop = scrollTop;
        this.interactionTicks = Date.now();
      }

      //prevent forever showing screen if nurse gets distracted and walks away
      if (Date.now() - this.interactionTicks > autoExitTicks) {
        this.props.done();
      }

    }, checkScrollTicks);
  }


  componentWillUnmount() {
    if (this.checkScrollInterval) {
      clearInterval(this.checkScrollInterval);
      delete this.checkScrollInterval;
    }
  }


  async tokenCallMbotSrvr(path, body, success, bad) {

    let settings = getShared()['settings'];
    if (!settings || !settings.getEnv()) {
      bad({ logStr: `Settings uninitialized` });
      return;
    }

    const timeoutTicks = 1000 * 15; //arbitrary

    body = body || {};

    let token = settings.getEnv().firestore.isSim ? 'valid' : settings.getAuthToken();

    let done = false;
    for (let attempt = 0; !done; ++attempt) {

      body.googleToken = token;

      let options = {
        method: 'PUT',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      };

      await clearFetch(`${getConfig().uiSimServer}/${path}`, options, {
        success: (json) => {
          success(json);
          done = true;
        },
        bad: async ({ netResult, logStr }) => {

          if (netResult?.status == 401 && attempt == 0) {
            console.log(`tokenCallMbotSrvr: refreshing token at ${new Date()}`);
            token = await settings.getEnv().refreshToken();

            //fallthrough to try a second time...
          }
          else {
            console.log(`tokenCallMbotSrvr: net call for ${path} failed: ${logStr}`);
            bad({ logStr });
            done = true;
          }
        }
      }, timeoutTicks);
    }
  }



  makeSendReport() {

    let sendReport = this.state.sendReport;
    let { startDateIdx, endDateIdx } = sendReport;

    let span = Math.round((this.startDates[endDateIdx].endTicks - this.startDates[startDateIdx].startTicks) / (1000 * 60 * 6)) / 10;
    let units = span <= 1 ? 'hour' : 'hours';
    if (span >= 24) {
      span = Math.round(span / 2.4) / 10;
      units = span <= 1 ? 'day' : 'days';

      if (span >= 7) {
        span = Math.round(span / 0.7) / 10;
        units = span <= 1 ? 'week' : 'weeks';
      }
    }

    let recentEmails = this.state.badgeData.recentEmails;

    return <div style={{
      display: 'flex', flexFlow: 'column', alignItems: 'center', justifyContent: 'center',
      position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, backgroundColor: 'white'
    }}
    >
      <div style={{ fontSize: 40, marginBottom: 30, fontWeight: 'bold' }}>Send CSV badge report via email</div>

      <div style={{ border: `1px solid gray`, padding: 20, display: 'flex', flexFlow: 'column', alignItems: 'center' }}>

        <div style={{ display: 'flex', flexFlow: 'row', alignItems: 'center' }}>
          <div style={{ fontSize: 30, marginRight: 10, textAlign: 'right', width: '5em' }}>Start date:</div>
          <WebPicker
            style={{ fontSize: 30, textAlign: 'center', border: `2px solid black`, width: '8em', cursor: 'pointer', padding: 2 }}
            menuItemStyle={{ fontSize: 30 }}
            onValueChange={itemValue => {
              this.interactionTicks = Date.now();
              this.setState({
                sendReport: {
                  ...sendReport, startDateIdx: itemValue,
                  endDateIdx: Math[ascDates ? 'max' : 'min'](itemValue, sendReport.endDateIdx)
                }
              });
            }}
            selectedValue={startDateIdx}
            values={this.startDateKeys}
            mapping={v => this.startDates[v].startDateLabel}
          ></WebPicker>
        </div>

        <div style={{ display: 'flex', flexFlow: 'row', alignItems: 'center', marginTop: 20 }}>
          <div style={{ fontSize: 30, marginRight: 10, textAlign: 'right', width: '5em' }}>End date:</div>
          <WebPicker
            style={{ fontSize: 30, textAlign: 'center', border: `2px solid black`, width: '8em', cursor: 'pointer', padding: 2 }}
            menuItemStyle={{ fontSize: 30 }}
            onValueChange={itemValue => {
              this.interactionTicks = Date.now();
              this.setState({
                sendReport: {
                  ...sendReport, endDateIdx: itemValue,
                  startDateIdx: Math[ascDates ? 'min' : 'max'](itemValue, sendReport.startDateIdx)
                }
              });
            }}
            selectedValue={endDateIdx}
            values={this.startDateKeys}
            mapping={v => v < 0 ? 'Now' : this.startDates[v].endDateLabel}
          ></WebPicker>
        </div>

        <div style={{ fontStyle: 'italic', fontSize: 18, marginTop: 15 }}>{`Selected span length: ${span} ${units}`}</div>

      </div>


      <div style={{ display: 'flex', flexFlow: 'row', alignItems: 'center', marginTop: 30 }}>

        {!recentEmails.length && <div style={{ fontSize: 30 }}>Email</div>}

        {!!recentEmails.length && <div style={{ display: 'flex', flexFlow: 'row', alignItems: 'center', marginLeft: 3, cursor: 'pointer' }}>
          <WebPicker
            style={{ fontSize: 20, textAlign: 'center', cursor: 'pointer', padding: 2 }}
            menuItemStyle={{ fontSize: 30 }}
            dropdownImg={<div style={{ display: 'flex', flexFlow: 'row', alignItems: 'center' }}>
              <div style={{ fontSize: 30, marginRight: 3 }}>Email</div>
              <img height={20} src={require('../assets/images/dropdown-triangle.png')} />
            </div>}
            onValueChange={itemValue => {
              this.interactionTicks = Date.now();
              this.emailRef.current.value = itemValue;
              this.setState({ sendReport: { ...sendReport, email: itemValue } });
            }}
            values={[...this.state.memEmails, ...recentEmails.map(e => e.email)].slice(0, 15)}
          ></WebPicker>
        </div>}

      </div>


      <input ref={this.emailRef}
        style={{
          // height: textBoxHeight,
          // borderColor: 'gray',
          padding: 8,
          width: '15em',
          fontSize: 30,
          // borderRadius: textBoxHeight * 0.5,
          // paddingLeft: 10,
          // paddingRight: 10,
        }}
        onChange={(e) => this.onEmailChange(e)}
        autoCapitalize={'none'}
        autoComplete={'off'}
        autoCorrect={'off'}
        spellCheck={'false'}
      />



      <div style={{ display: 'flex', flexFlow: 'row', alignItems: 'center', marginTop: 30 }}>
        <div style={turqoiseBtnStyle({ marginRight: 30 })} onClick={() => {
          this.interactionTicks = Date.now();
          this.setState({ sendReport: undefined });
        }}>Cancel</div>
        <div style={turqoiseBtnStyle()} onClick={() => this.sendReportOkClicked()}>Send</div>
      </div>
    </div>
  }

  onEmailChange(e) {
    this.setState({ sendReport: { ...this.state.sendReport, email: e.target.value } });
    this.interactionTicks = Date.now();
  }

  async sendReportOkClicked() {
    this.interactionTicks = Date.now();

    let { sendReport } = this.state;
    if (!sendReport) return;
    let email = sendReport.email.trim();
    if (!email) {
      this.setState({ userMsg: `Please enter an email address.` });
      return;
    }

    if (!emailRE.exec(email.toLowerCase())) {
      this.setState({ userMsg: `The entered email address does not appear to be valid.` });
      return;
    }

    let { startDateIdx, endDateIdx } = sendReport;

    let startTicks = this.startDates[startDateIdx].startTicks;
    let endTicks = this.startDates[endDateIdx].endTicks;

    let unit = getUnitWp(); //TODO in light of when this.props.station == '*'

    let body = { unit, startTicks, endTicks, email };

    let badgeData;
    await this.tokenCallMbotSrvr('sendReport', body,
      json => {

        let startLabel = this.startDates[startDateIdx].startDateLabel;
        let endLabel = this.startDates[endDateIdx].endDateLabel;

        if (json.error) {
          let msg = `Report attempted to ${email} by ${r2h(unit)} spanning ${startLabel} - ${endLabel}: ${json.error}`;
          elasticLogError({ what: 'reportLogicalErr', msg, error: json.error, unit, startTicks, endTicks, email });
          this.setState({ userMsg: json.error });
          return;
        }

        //report was successfully sent
        let msg = `Report sent to ${email} by ${r2h(unit)} spanning ${startLabel} - ${endLabel}`;
        elasticLogEvent({ what: 'reportSent', msg, unit, startTicks, endTicks, email });

        let userMsg = `A report has been sent to ${email} for the span ${startLabel} - ${endLabel}.`;
        this.setState({ sendReport: undefined, userMsg });

        //keep in-mem history of emails that weren't persisted at the time we loaded
        if (
          !this.state.badgeData.recentEmails.find(r => r.email == email) &&
          !this.state.memEmails.find(e => e == email)
        ) {
          let memEmails = [email, ...this.state.memEmails];
          this.setState({ memEmails });
        }
      },
      ({ logStr }) => {
        let msg = `Error sending report: ` + logStr;
        elasticLogError({ what: 'reportErr', msg });
        this.setState({ userMsg: msg });
      }
    );
  }


  render() {

    const flexCol = { display: 'flex', flexFlow: 'column', alignItems: 'center' };
    const flexRow = { display: 'flex', flexFlow: 'row', alignItems: 'center' };
    const coverAll = {
      display: 'flex', flexFlow: 'column', height: '100vh', width: '100%',
      flex: 1, alignItems: 'center', justifyContent: 'center', position: 'relative'
    };

    if (this.state.loading) {
      return <div style={coverAll}>
        <div style={{ fontStyle: 'italic', fontSize: 30 }}>Loading task data, one moment...</div>
        <div style={turqoiseBtnStyle({ marginRight: 20, marginTop: 30 })} onClick={() => this.props.done()}>Cancel</div>
      </div>
    }

    if (this.state.loadErr) {
      return <div style={{ ...coverAll, padding: 30, textWrap: 'balance', textAlign: 'center' }}>
        <div style={{ fontSize: 30 }}>{`Could not retrieve task data: ${this.state.loadErr}.`}</div>
        <div style={turqoiseBtnStyle({ marginRight: 20, marginTop: 30 })} onClick={() => this.props.done()}>Ok</div>
      </div>
    }

    let recs = this.state.badgeData.badges;
    let names = this.props.showNames;

    const getDayDTStr = (ticks, includeSeconds) => {
      let d = new Date(ticks);
      let [mo, da, dowIdx] = [d.getMonth() + 1, d.getDate(), d.getDay()];
      return `${DAYS_OF_WEEK_ABBREV[dowIdx]} ${mo}/${da} ${getHrsMinsAmpmStr(ticks, includeSeconds)}`;
    }

    const mapOutcome = swipeCode => {
      let text = swipeCodeMap[swipeCode] || `Fail type ${swipeCode}`;
      let color = swipeCode == 0 ? pleasantGreen : alertRed;
      return <div style={{ color, fontWeight: 'bold' }}>{text}</div>
    };


    const badgeFilt = (badges, isExpanded) => {
      if (isExpanded)
        return badges;

      let seen = {};
      let results = badges.filter(b => {
        if (b.outcome) return; //in this phase we're looking for successes

        let k = `${getBadgeId(b, names)}:${b.drawersStr}`;
        if (seen[k]) return; //don't show redundancies

        seen[k] = true;
        return true;
      });

      //no successes, so show the most recent failure (if any)
      if (!results.length)
        results = [badges.findLast(b => b.outcome)].filter(Boolean);
      return results;
    }

    return <div style={coverAll}>

      <Header primeAudio={(makeSound) => this.props.primeAudio(makeSound)} />

      {!recs.length && <div style={{ height: '100%', width: '100%', ...flexRow, justifyContent: 'center', fontStyle: 'italic', fontSize: 30 }}>
        {`No records currently found for ${this.props.station == '*' ? 'any station' : r2h(this.props.station)}.`}
      </div>}

      {!!recs.length && <div ref={this.scrollRef} className={'badge-view'}
        style={{
          overflowY: 'auto', overflowX: 'hidden', flex: 1, cursor: 'default', ...noSelect, width: '90%',
          border: `1px solid gray`, borderRadius: 8, marginTop: 20, position: 'relative'
        }}>
        {recs.map((rec, i) => {
          console.log(rec);
          let { pickupBadges, dropoffBadges, batchType, batchIndex, batchTotal } = rec;

          // let hasMoreBadges = pickupBadges.length > 1 || dropoffBadges.length > 1;
          let isExpanded = !!this.state.expanded[rec.taskId];

          // let pickSwipes = isExpanded ? pickupBadges : [pickupBadges.findLast(b => !b.outcome) || arrLast(pickupBadges)].filter(Boolean); 
          // let dropSwipes = isExpanded ? dropoffBadges : [dropoffBadges.findLast(b => !b.outcome) || arrLast(dropoffBadges)].filter(Boolean); 

          let pickSwipes = badgeFilt(pickupBadges, isExpanded);
          let dropSwipes = badgeFilt(dropoffBadges, isExpanded);
          let hasMoreBadges = isExpanded || pickSwipes.length != pickupBadges.length || dropSwipes.length != dropoffBadges.length;

          let batchStr;
          if (batchType)
            batchStr = `${batchType == 'oneToMany' ? 'One to Many' : 'Many to One'} (${batchIndex + 1} of ${batchTotal})`;

          let securityStr = rec.restricted == 2 ? 'MFA' : (rec.restricted == 1 ? 'Restricted' : undefined);

          let moreData;
          if (batchStr || securityStr) {
            let marginLeft = batchStr ? 8 : 0;
            moreData = <div style={{ fontSize: 16, display: 'flex', flexFlow: 'row', alignItems: 'center' }}>
              {!!batchStr && <div>{batchStr}</div>}
              {!!securityStr && <div style={{ fontWeight: 'bold', color: pleasantOrange, marginLeft }}>{securityStr}</div>}
            </div>
          }

          let overrideStr;
          if (rec.override)
            overrideStr = ['option', 'recipient', 'reason'].map(k => rec.override[k]).filter(Boolean).join(' / ');

          return <div key={`task-${rec.taskId}`} style={{ ...flexCol, fontSize: 20, width: '100%' }}>

            {!!i && <hr style={{ border: `1px solid #47b7b9`, width: '100%', marginLeft: 5, marginRight: 5 }} />}

            <div style={{ ...flexRow, fontSize: 20, width: '100%', position: 'relative', cursor: 'pointer' }}
              onClick={() => {
                if (!isExpanded && !hasMoreBadges) return;
                let expanded = { ...this.state.expanded };
                isExpanded ? delete expanded[rec.taskId] : expanded[rec.taskId] = true;
                this.setState({ expanded });
              }}
            >

              <div style={{ width: '50%', ...flexCol }}>
                <div style={{ fontSize: 24 }}>
                  <span style={{ fontWeight: 'bold' }}>{`TaskId  ${rec.taskId.slice(0, 6)}`}</span>
                  <span style={{ fontSize: 24, marginLeft: 8 }}>{`(${rec.robot})`}</span>
                </div>
                <div style={{ fontSize: 16 }}>{`Requested ${getDayDTStr(rec.taskCreatedTicks)}`}</div>
                {moreData}

                {!!rec.note && <div
                  style={{
                    fontSize: 14, padding: '2px', border: `1px solid #bbbb`,
                    borderRadius: 4, textAlign: 'center'
                  }}
                >{rec.note}</div>}
              </div>

              <div style={{ width: '50%', ...flexCol }}>
                <div style={flexRow}>
                  <div style={{ fontSize: 16, marginRight: 5 }}>Pickup:</div>
                  <div style={{ fontWeight: 'bold' }}>{r2h(rec.pickup)}</div>
                </div>

                <div style={{ width: '100%', display: 'flex', flexFlow: 'column', alignItems: 'center' }}>
                  {!pickSwipes.length && <div style={{ fontSize: 16, fontStyle: 'italic', display: 'flex', flexFlow: 'row', alignItems: 'center' }}>
                    (No pickup badge records found)
                  </div>}
                  {pickSwipes.map(b => {
                    return <div style={{ fontSize: 16, display: 'flex', flexFlow: 'row', alignItems: 'center' }}>
                      <div style={{ marginRight: 5 }}>{`${getBadgeId(b, names)} @ ${getDayDTStr(b.ticks, isExpanded)}`}</div>
                      {mapOutcome(b.outcome)}
                      {!b.outcome && !!b.drawersStr && <div style={{ marginLeft: 3 }}>{`(${b.drawersStr})`}</div>}
                    </div>
                  })}
                </div>

                <hr style={{ width: '50%', border: '1px solid #BBB' }} />

                <div style={flexRow}>
                  <div style={{ fontSize: 16, marginRight: 5 }}>Dropoff:</div>
                  <div style={{ fontWeight: 'bold' }}>{r2h(rec.dropoff)}</div>
                </div>

                <div style={{ width: '100%', display: 'flex', flexFlow: 'column', alignItems: 'center' }}>
                  {!dropSwipes.length && <div style={{ fontSize: 16, fontStyle: 'italic', display: 'flex', flexFlow: 'row', alignItems: 'center' }}>
                    (No dropoff badge records found)
                  </div>}
                  {dropSwipes.map(b => {
                    return <div style={{ fontSize: 16, display: 'flex', flexFlow: 'row', alignItems: 'center' }}>
                      <div style={{ marginRight: 5 }}>{`${getBadgeId(b, names)} @ ${getDayDTStr(b.ticks, isExpanded)}`}</div>
                      {mapOutcome(b.outcome)}
                      {!b.outcome && !!b.drawersStr && <div style={{ marginLeft: 3 }}>{`(${b.drawersStr})`}</div>}
                    </div>
                  })}
                  {!!overrideStr && <div style={{ fontSize: 16, display: 'flex', flexFlow: 'row', alignItems: 'center' }}>
                    <div style={{ marginRight: 5 }}>Override:</div>
                    <div>{overrideStr}</div>
                  </div>}
                </div>
              </div>

              {!!hasMoreBadges && <div style={{
                position: 'absolute', right: 0, top: 0, bottom: 0,
                width: 50, display: 'flex', flexFlow: 'column', alignItems: 'center', justifyContent: 'center'
              }}>

                <img width={20} src={require(`../assets/images/badge-detail-${isExpanded ? 'collapse' : 'expand'}.png`)} />

              </div>}

            </div>
          </div>
        })}
      </div>}

      <div style={{ display: 'flex', flexFlow: 'row', alignItems: 'center', marginBottom: 30, marginTop: 20, width: '80%' }}>

        <div style={{ flex: 1 }}></div>

        {false && !!recs.length && <div style={turqoiseBtnStyle({ marginRight: 20 })}
          onClick={() => {
            this.interactionTicks = Date.now();
            this.setState({
              sendReport: {
                startDateIdx: ascDates ? this.startDates.length - 1 : 0,
                endDateIdx: ascDates ? this.startDates.length - 1 : 0,
                email: ''
              }
            });
          }}
        >Send report...</div>}

        <div style={turqoiseBtnStyle()} onClick={() => this.props.done()}>Done</div>
      </div>

      {!!this.state.sendReport && this.makeSendReport()}

      {!!this.state.userMsg && <div style={{
        position: 'absolute', left: 0, top: 0, right: 0, bottom: 0,
        display: 'flex', flexFlow: 'column', alignItems: 'center', justifyContent: 'center',
        backgroundColor: '#666', opacity: 0.95
      }}>

        <div style={{
          backgroundColor: 'white', border: `2px solid #47b7b9`, padding: 30,
          borderRadius: 16, maxWidth: '50%'
        }}>

          <div style={{
            fontSize: 30, fontWeight: 'bold', textWrap: 'balance', textAlign: 'center',
            ...noSelect
          }}>{this.state.userMsg}</div>


          <div style={{ display: 'flex', flexFlow: 'row', alignItems: 'center' }}>
            <div style={{ flex: 1 }} />
            <div style={turqoiseBtnStyle({ marginTop: 30, maxWidth: '4em' })}
              onClick={() => {
                this.setState({ userMsg: undefined });
                this.interactionTicks = Date.now();
              }}
            >Ok</div>
            <div style={{ flex: 1 }} />
          </div>
        </div>

      </div>}

    </div>
  }
}


function dateStr(ticks) {
  let d = new Date(ticks);
  return `${ShortMonth[d.getMonth()]} ${d.getDate()}`;
}


